import { connect } from "@formily/react";
import { Password as AntPassword } from "@formily/antd-v5";

export const Password = connect((props) => {
  const enhancedProps = {
    ...props,
  };

  return <AntPassword {...enhancedProps} />;
});
